var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 1228,
    viewBox: "0 0 493 1228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.03,
    width: 164.03,
    height: 642.307,
    fill: "#EBE9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.059 0C328.059 22.7093 323.816 45.1963 315.573 66.177C307.33 87.1577 295.248 106.221 280.016 122.279C264.784 138.337 246.702 151.075 226.801 159.765C206.9 168.456 185.57 172.929 164.03 172.929L164.03 0H328.059Z",
    fill: "#3AA0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.57764e-05 0C-4.57764e-05 22.7093 4.24271 45.1963 12.486 66.177C20.7292 87.1577 32.8116 106.221 48.0431 122.279C63.2747 138.337 81.3571 151.075 101.258 159.765C121.159 168.456 142.489 172.929 164.03 172.929L164.03 0H-4.57764e-05Z",
    fill: "#D3DDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.03,
    y: 471.437,
    width: 164.941,
    height: 520.845,
    rx: 82.4704,
    fill: "#7CB0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 172.929,
    width: 164.03,
    height: 783.326,
    rx: 82.0148,
    fill: "#7CB0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 328.97,
    width: 164.03,
    height: 1228,
    rx: 82.0148,
    fill: "#3AA0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.059 1228C328.059 1205.29 323.816 1182.8 315.573 1161.82C307.33 1140.84 295.248 1121.78 280.016 1105.72C264.784 1089.66 246.702 1076.93 226.801 1068.23C206.9 1059.54 185.57 1055.07 164.03 1055.07L164.03 1228H328.059Z",
    fill: "#3AA0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1667 367.474C36.7873 367.474 0 404.261 0 449.64V1145.83C0 1157.5 2.43119 1168.6 6.81455 1178.65C8.42459 1172.94 10.3158 1167.32 12.4838 1161.8C20.7255 1140.81 32.8057 1121.74 48.0345 1105.67C63.2633 1089.61 81.3425 1076.86 101.24 1068.17C121.137 1059.47 142.463 1055 164 1055L164 1153.29C164.221 1150.83 164.333 1148.35 164.333 1145.83V449.64C164.333 404.261 127.546 367.474 82.1667 367.474Z",
    fill: "#3AA0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 328.97,
    y: 332.476,
    width: 164.03,
    height: 659.806,
    rx: 82.0148,
    fill: "#D3DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M493 418.94C482.23 418.94 471.565 416.704 461.614 412.359C451.664 408.014 442.623 401.645 435.007 393.616C427.391 385.587 421.35 376.055 417.228 365.565C413.107 355.074 410.985 343.831 410.985 332.476L493 332.476L493 418.94Z",
    fill: "#3AA0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.985 332.476C410.985 343.831 408.864 355.074 404.742 365.565C400.621 376.055 394.579 385.587 386.964 393.616C379.348 401.645 370.307 408.014 360.356 412.359C350.406 416.704 339.741 418.94 328.97 418.94L328.97 332.476H410.985Z",
    fill: "#3AA0FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticks);
export default __webpack_public_path__ + "static/media/sticks.af524f2eb9ee935e8f50742785f693a5.svg";
export { ForwardRef as ReactComponent };